module.exports = __webpack_public_path__ + "img/advant4.33170626.png";